
<template>
    <div class="row gy-2">
      <div class="col-12">
        <div class="card mb-0">
          <div class="card-header">
            <h5 class="card-title mb-0">Your Dependants</h5>
          </div>
          <div class="card-body p-3">
            <div class="table-responsive mb-0 loading-viewport">
              <CommonSpinner v-if="isLoading" :box="true" />
              <b-table striped hover ref="selectableTable" :items="pageData.data"
                :fields="columns" responsive="sm"  align="middle">
                <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                  v-slot:[`head(${column.key})`] >
                    <div :key="colIndex" @click="setSortOrder(column)" class="cursor-pointer
                    d-flex align-items-center">
                      {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                    </div>
                </template>
                <template v-for="(column, colIndex) in columns.filter((i) => i.auto)"
                    v-slot:[`cell(${column.key})`]="data">
                    <div @click="navigateTo(data.item.id)" :key="colIndex" 
                        :style="{ 'width': `${column.width || '7'}rem` }" class="cursor-pointer d-flex align-items-center">
                        <CommonTableTemplate :item="data.item" :column="column" />
                    </div>
                </template>
              </b-table>
              <p v-if="!isLoading && !pageData.data.length" class="text-center text-muted">No Dependants to show</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import _ from 'lodash';
  import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
  import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';
  
  export default {
    name: "employee-dependants",
    mixins: [
      commonSortingMixin,
      commonPaginationMixin
    ],
    data() {
      return {
        isLoading: false,
        searchQuery: "",
        columns: [
            { key: "first_name", auto: true, label: "First Name" },
            { key: "last_name", auto: true, label: "Last Name" },
            { key: "middle_name", auto: true, label: "Middle Name" },
            { key: "phone_number", auto: true, label: "Phone Number" },
            { key: "marital_status", auto: true, label: "Marital Status" },
            { key: "gender", auto: true, label: "Gender" },
            { key: "date_of_birth", auto: true, label: "Date of Birth" },
            { key: "nin", auto: true, label: "NIN" },
            { key: "address", auto: true, width: 15, label: "Address" },
            { key: "is_next_of_kin", auto: true, label: "Next of Kin" },
            { key: "has_financial_right", auto: true, label: "Has Financial Right" },
            { key: "relationship_title", auto: true, label: "Relationship" },
            { key: "created_at", auto: true, label: "Created At" }
        ],
        sortBy: {
          sort_column: "created_at",
          sort_direction: "desc"
        },
        pageData:{
          data: []
        },
        perPage: 10
      }
    },
    methods: {
      navigateTo(id){
  
      },
      updateSearchQuery: _.debounce(function(string) {
        this.fetchItems()
      }, 2000),
      fetchItems(page, per_page = null) {
        let payload = {
            page: page || 1, per_page: per_page || this.itemsPerPage,
            ...this.sortBy
        }
        if(this.searchQuery){ payload.search = this.searchQuery }
        this.isLoading = true
        this.$http.get(`/dependants?${new URLSearchParams(payload).toString()}`)
          .then((response) => {
            this.isLoading = false
            if(response.data.success){
              this.pageData = response.data.data
              this.initializeAll();
            }
          })
      },
      initializeAll(){
      },
    },
    created(){
      this.fetchItems()
    },
  }
  
  </script>
  
  